// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"

require('../src/application_v2.scss')
const images = require.context('../images/', true)
const imagePath = name => images(name, true)

Rails.start()

import * as AutoKana from 'vanilla-autokana'
window.AutoKana = AutoKana
